// extracted by mini-css-extract-plugin
export default {"wrapper":"styles__wrapper___SNCJd"};